import React, { Component } from 'react'

class NV extends Component {
  render() {
    return (
      <symbol id="statesvg-NV" width="100" height="100" viewBox="0 0 100 100">
        <path d="M80.78,80.84l-.58,1.89-.71.23-1.88-1.53H75.49l-1.89.71,1.06,7.53.83,4.12L75,96.5,19.22,43.05l2-39.55L50.29,4.79l29.32-.23Z" />
      </symbol>
    )
  }
}

export default NV
